module.exports = __webpack_public_path__ + "static/group-1-f270b012ce802589bbd647939979274f.png";